var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"name":"v-dialog","persistent":"","fullscreen":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }